/**
 * Sky GPU quality: freeze a snapshot when the hour is held, half-res on low-memory.
 */

export var SKY_RENDER_SCALE_LOW = 0.5;
export var SKY_LOW_MEMORY_GB = 4;

/**
 * @param {{ deviceMemory?: number }} [hints]
 * @returns {number} 1 or 0.5
 */
export function skyRenderScale(hints) {
  var mem = Number(hints && hints.deviceMemory);
  if (isFinite(mem) && mem > 0 && mem < SKY_LOW_MEMORY_GB) return SKY_RENDER_SCALE_LOW;
  return 1;
}

/**
 * @param {object} [u] uniforms from buildSkyShaderUniforms
 * @returns {string}
 */
export function skyUniformsFingerprint(u) {
  if (!u) return "none";
  if (u.solid) {
    var rgb = u.solidRgb || [];
    return "solid:" + rgb[0] + "," + rgb[1] + "," + rgb[2];
  }
  return [
    round3(u.colorPhase),
    round3(u.seaLineY),
    round3(u.bodyX),
    round3(u.bodyY),
    round3(u.bodyRadius),
    round3(u.emergence),
    round3(u.animSec),
    round3(u.starAlpha),
    u.isDay ? 1 : 0,
    round3(u.sunAlpha),
    u.cloudCount || 0,
    round3(u.nightAmount),
    u.drawClouds ? 1 : 0,
    u.drawCelestial ? 1 : 0,
    u.discVisible ? 1 : 0,
  ].join("|");
}

function round3(v) {
  var n = Number(v);
  if (!isFinite(n)) return 0;
  return Math.round(n * 1000) / 1000;
}
